export default __webpack_public_path__ + "static/media/themebel_mobile.9074cf6f.svg";